/* VialArt — abandon-cart saver. When a shopper with items in their cart shows
   exit intent (desktop: mouse leaves the top of the window; mobile: back gesture
   or long idle), offer 10% off via the COMEBACK10 code with a 1-hour on-screen
   countdown. The code itself is evergreen — the timer is per-visitor urgency,
   persisted in localStorage so it doesn't reset on reload. Shows once per
   session, never on checkout, never if the code is already on the cart.
   Fail-open everywhere. */
(function () {
  'use strict';
  var CODE = 'COMEBACK10', PCT = 10, HOUR = 3600000;
  var SHOWN = 'va_cs_shown', DEADLINE = 'va_cs_deadline', USED = 'va_cs_used';

  // never on checkout / order-status / the discount route itself
  var path = location.pathname.toLowerCase();
  if (path.indexOf('/checkout') === 0 || path.indexOf('/discount/') === 0 || /\/orders?\//.test(path) || path.indexOf('/pages/ai-label-studio') === 0) return;
  // Shopify theme editor — don't pop inside the admin preview
  if (window.Shopify && window.Shopify.designMode) return;

  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  var shownThisSession = false, armed = false, deadline = 0;

  function haveCart(cb) {
    try {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (!c || !c.item_count) { cb(false); return; }
          // already discounted? (COMEBACK10 or any cart-level discount applied)
          var codes = (c.cart_level_discount_applications || []).map(function (d) { return (d.title || d.code || '').toUpperCase(); });
          if (codes.indexOf(CODE) > -1) { cb(false); return; }
          cb(true);
        })
        .catch(function () { cb(false); });
    } catch (e) { cb(false); }
  }

  function fmt(ms) {
    if (ms < 0) ms = 0;
    var s = Math.floor(ms / 1000), m = Math.floor(s / 60); s = s % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  function css() {
    if (document.getElementById('va-cs-css')) return;
    var st = document.createElement('style'); st.id = 'va-cs-css';
    st.textContent =
      '.va-cs-ov{position:fixed;inset:0;z-index:2147483000;background:rgba(8,5,20,.72);backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);display:flex;align-items:center;justify-content:center;padding:20px;animation:vaCsIn .2s ease}'
      + '@keyframes vaCsIn{from{opacity:0}to{opacity:1}}'
      + '@keyframes vaCsPop{from{transform:translateY(14px) scale(.97);opacity:0}to{transform:none;opacity:1}}'
      + '.va-cs-card{position:relative;width:100%;max-width:400px;background:linear-gradient(160deg,#1c1140,#241653);border:1px solid rgba(124,77,255,.5);border-radius:20px;padding:28px 24px 24px;text-align:center;color:#fff;box-shadow:0 30px 80px rgba(6,3,18,.6);animation:vaCsPop .28s cubic-bezier(.2,.8,.2,1)}'
      + '.va-cs-x{position:absolute;top:12px;right:14px;background:none;border:0;color:#8d82b5;font-size:22px;line-height:1;cursor:pointer;padding:4px 8px}'
      + '.va-cs-x:hover{color:#fff}'
      + '.va-cs-emj{font-size:40px;line-height:1;margin-bottom:6px}'
      + '.va-cs-h{font-size:23px;font-weight:900;letter-spacing:-.3px;margin:0 0 6px}'
      + '.va-cs-h .p{color:#c3a8ff}'
      + '.va-cs-sub{font-size:14px;color:#c9bff0;line-height:1.5;margin:0 0 16px}'
      + '.va-cs-timerlbl{font-size:11px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;color:#a98bff;margin-bottom:5px}'
      + '.va-cs-timer{font-variant-numeric:tabular-nums;font-size:34px;font-weight:900;letter-spacing:1px;color:#fff;margin-bottom:4px}'
      + '.va-cs-timer.done{color:#ff8b8b;font-size:20px}'
      + '.va-cs-code{display:inline-block;margin:12px 0 4px;padding:8px 16px;border:1.5px dashed rgba(169,139,255,.7);border-radius:10px;font-size:16px;font-weight:800;letter-spacing:2px;color:#e9deff;background:rgba(124,77,255,.12)}'
      + '.va-cs-go{display:block;width:100%;margin-top:16px;border:0;border-radius:13px;padding:15px;font-size:16px;font-weight:800;cursor:pointer;background:linear-gradient(120deg,#7c4dff,#9b6bff);color:#fff;font-family:inherit;transition:filter .12s}'
      + '.va-cs-go:hover{filter:brightness(1.08)}'
      + '.va-cs-no{margin-top:11px;background:none;border:0;color:#8d82b5;font-size:12.5px;cursor:pointer;font-family:inherit;text-decoration:underline}'
      + '.va-cs-no:hover{color:#cdbff2}';
    document.head.appendChild(st);
  }

  var tick = null;
  function show() {
    if (shownThisSession || document.getElementById('va-cs-ov')) return;
    shownThisSession = true; ss(SHOWN, '1');
    css();
    var ov = document.createElement('div'); ov.className = 'va-cs-ov'; ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true'); ov.setAttribute('aria-label', 'Special offer');
    ov.innerHTML =
      '<div class="va-cs-card">'
      + '<button type="button" class="va-cs-x" aria-label="Close">&times;</button>'
      + '<div class="va-cs-emj">&#128075;</div>'
      + '<h2 class="va-cs-h">Wait &mdash; here&rsquo;s <span class="p">' + PCT + '% off</span></h2>'
      + '<p class="va-cs-sub">Your custom labels are ready &mdash; use the code below for ' + PCT + '% off your order.</p>'
      + '<div class="va-cs-code">' + CODE + '</div>'
      + '<button type="button" class="va-cs-go">Apply my ' + PCT + '% off &rarr;</button>'
      + '<button type="button" class="va-cs-no">No thanks, I&rsquo;ll pay full price</button>'
      + '</div>';
    document.body.appendChild(ov);
    function close() { try { clearInterval(tick); } catch (e) {} try { ov.remove(); } catch (e) {} document.removeEventListener('keydown', onkey); }
    function onkey(e) { if (e.key === 'Escape' || e.keyCode === 27) close(); }
    document.addEventListener('keydown', onkey);
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    ov.querySelector('.va-cs-x').onclick = close;
    ov.querySelector('.va-cs-no').onclick = close;
    ov.querySelector('.va-cs-go').onclick = function () {
      ls(USED, '1');
      try { if (window.vaTrack) window.vaTrack('cart_save_claim', { c: CODE }); } catch (e) {}
      window.location.href = '/discount/' + CODE + '?redirect=/cart';
    };
    try { if (window.vaTrack) window.vaTrack('cart_save_shown', { c: CODE }); } catch (e) {}
  }

  function arm() {
    if (armed) return; armed = true;
    var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

    // desktop: mouse leaves the top edge of the viewport (heading for the tab bar / close)
    if (!isTouch) {
      document.addEventListener('mouseout', function (e) {
        if (shownThisSession) return;
        if (e.clientY <= 2 && !e.relatedTarget && !e.toElement) show();
      });
    } else {
      // mobile: catch the back gesture once (history trap), plus a long-idle fallback
      try {
        history.pushState({ vacs: 1 }, '');
        window.addEventListener('popstate', function () {
          if (shownThisSession) return;
          try { history.pushState({ vacs: 1 }, ''); } catch (e) {}
          show();
        });
      } catch (e) {}
      var idle = setTimeout(function () { if (!shownThisSession) show(); }, 45000);
      ['touchstart', 'scroll', 'keydown'].forEach(function (ev) {
        window.addEventListener(ev, function () { clearTimeout(idle); idle = setTimeout(function () { if (!shownThisSession) show(); }, 45000); }, { passive: true });
      });
    }
  }

  function boot() {
    if (ss(SHOWN) === '1') return;          // already offered this session
    haveCart(function (ok) { if (ok) arm(); });
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
